import React from 'react'
import { NumericFormat } from 'react-number-format'
import { TextInput, Typography } from 'gu-ui-kit'
import styles from 'components/FormControls/form-controls.module.scss'
import clsx from 'clsx'
import { useSelector } from 'react-redux'

const renderAmountField = ({
  input,
  meta: { touched, error, submitting, form },
  InputProps = { className: '' },
  placeholder = null,
  required: requiredProp,
  ...rest
}) => {
  const requiredFromSchema = useSelector(
    (state) => state['forms/meta']?.[form]?.[input.name] ?? false,
  )
  const required = requiredProp ?? requiredFromSchema
  const locale = global.locale
  const decimalSeparator = locale === 'ru' ? ',' : '.'
  return (
    <NumericFormat
      customInput={TextInput}
      thousandSeparator={' '}
      allowLeadingZeros={true}
      decimalScale={2}
      decimalSeparator={decimalSeparator}
      fixedDecimalScale
      placeholder={placeholder || `0${decimalSeparator}00`}
      {...rest}
      {...input}
      required={required}
      disabled={submitting || rest.disabled}
      helperText={touched && error ? rest.t(error) : rest.helperText}
      error={!!(touched && error)}
      InputProps={{
        className: clsx(styles['input-field'], InputProps.className),
        startAdornment: InputProps.startAdornment,
        endAdornment:
          InputProps.endAdornment ||
          (rest.currency && (
            <Typography
              variant={'Body-25'}
              noMargin
              color={'Label-Secondary'}
            >
              {rest.currency}
            </Typography>
          )),
      }}
    />
  )
}

export default renderAmountField
